(function () {
  const toggles = document.querySelectorAll("[data-js-disclaimer-toggle");

  for (const toggle of toggles) {
    const dialog = toggle.nextElementSibling;
    if (!dialog || dialog.tagName.toLowerCase() !== "dialog") return;

    const close = dialog.querySelector("[data-js-dialog-close]");

    const hideDialog = () => {
      dialog.dataset.fadeOut = true;

      dialog.addEventListener(
        "animationend",
        () => {
          dialog.dataset.fadeOut = false;
          dialog.close();
        },
        {
          once: true,
        }
      );
    };

    toggle.addEventListener("click", () => {
      dialog.showModal();
    });

    dialog.addEventListener("click", (e) => {
      if (e.target === dialog) hideDialog();
    });

    close.addEventListener("click", () => {
      hideDialog();
    });
  }
})();
